var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHandShake(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 21,
    viewBox: "0 0 25 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0656 9.67476L20.75 10.6506L17.75 5.79537L20.0938 4.80371C20.2679 4.72858 20.4701 4.71477 20.6563 4.7653C20.8425 4.81583 20.9975 4.92659 21.0875 5.07344L23.3937 8.81003C23.4405 8.88483 23.4691 8.96679 23.4779 9.05108C23.4867 9.13538 23.4755 9.22031 23.4449 9.30088C23.4143 9.38145 23.365 9.45603 23.2999 9.52024C23.2348 9.58445 23.1551 9.63699 23.0656 9.67476V9.67476Z",
    stroke: "#0E2B63",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.24984 10.5712L1.93422 9.58748C1.84506 9.5505 1.76559 9.49873 1.70055 9.43524C1.63551 9.37175 1.58622 9.29785 1.55561 9.21792C1.52499 9.13798 1.51369 9.05366 1.52236 8.96996C1.53103 8.88625 1.55951 8.80488 1.60609 8.73068L3.91234 4.99409C4.00256 4.84735 4.15691 4.73621 4.34253 4.68435C4.52814 4.63248 4.73035 4.64399 4.90609 4.71642L7.24984 5.70809L4.24984 10.5712Z",
    stroke: "#0E2B63",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.75 10.6506L19.25 12.1421L15.8 15.0615C15.706 15.1359 15.592 15.19 15.468 15.219C15.3439 15.248 15.2133 15.2511 15.0875 15.2281L9.65 14.0778C9.55067 14.0544 9.45812 14.0139 9.37812 13.9588L4.25 10.5713",
    stroke: "#0E2B63",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2496 12.1421L15.1246 9.6034L13.9246 10.365C13.4047 10.6934 12.7733 10.8708 12.1246 10.8708C11.4759 10.8708 10.8445 10.6934 10.3246 10.365L9.81834 10.0397C9.73274 9.98466 9.66193 9.91483 9.61061 9.83486C9.55929 9.75489 9.52862 9.6666 9.52065 9.57585C9.51267 9.4851 9.52756 9.39395 9.56434 9.30844C9.60111 9.22292 9.65893 9.14499 9.73397 9.07981L13.409 5.97788C13.478 5.91975 13.5599 5.87371 13.65 5.8424C13.7401 5.81109 13.8366 5.79513 13.934 5.79541H17.7496",
    stroke: "#0E2B63",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.30664 5.708L12.116 4.518C12.2869 4.47653 12.4696 4.48778 12.6316 4.54973L15.8754 5.79526",
    stroke: "#0E2B63",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11 16.9021L8.17813 16.2992C8.06313 16.2772 7.95666 16.2308 7.86875 16.1643L5.75 14.6094",
    stroke: "#0E2B63",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandShake);
export default __webpack_public_path__ + "static/media/hand-shake.1e16e7d79a28e3877c4433d1368d9f24.svg";
export { ForwardRef as ReactComponent };